import React from "react";

const PageHeader = ({ title, bgImage }) => {
  return (
    <section
      style={{
        background: `url(${bgImage}) center center / cover no-repeat`,
      }}
     className="head-bar">
      {/* DARK OVERLAY */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.4)", // optional overlay
        }}
      ></div>

      {/* TEXT CENTER BOX */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          bottom: "-22px",
          transform: "translateX(-50%)",
          background: "#002751",
          padding: "12px 35px",
          borderRadius: "4px",
          color: "#fff",
          fontSize: "27px",
          fontWeight: "700",
          textAlign: "center",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          zIndex: 2,
        }}
      >
        {title}
      </div>
    </section>
  );
};

export default PageHeader;
